import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60d7b66b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=60d7b66b&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=60d7b66b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7b66b",
  null
  
)

export default component.exports